import { Component, ElementRef, Input, OnInit, ViewChild, forwardRef } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ModalService } from 'src/app/modals/modal.service';
import { SignatureService } from 'src/app/services/signatures.service';
import SignaturePad from "signature_pad";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => { };

@Component({
    selector: 'paetep-signature',
    templateUrl: './paetep-signature.component.html',
    styleUrls: ['./paetep-signature.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => PaetepSignatureComponent)
        }
    ]
})
export class PaetepSignatureComponent implements OnInit, ControlValueAccessor {
    @Input() hideActionsWhenDisabled: boolean = false;
    @Input() isPrintMode: boolean = false;
    @Input() isReadOnly: boolean = false;

    @ViewChild("signatureCanvas", { static: true }) canvas?: ElementRef<HTMLCanvasElement>;

    constructor(
        private signatureService: SignatureService,
        private modalService: ModalService
    ) { }

    public singaturePad?: SignaturePad;

    private _signature: string | undefined | null;
    private _disabled: boolean = false;

    get signature(): string | undefined | null {
        return this._signature;
    }

    set signature(value: string | undefined | null) {
        this._signature = value;
        this.setSignature(value, this.singaturePad);
        this.onTouchedCallback();
        this.onChangeCallback(this._signature);
    }

    get disabled() {
        return this._disabled || this.isReadOnly;
    }

    set disabled(value: boolean) {
        this._disabled = value;
    }

    private setSignature = (signature?:string | undefined | null, sigPad?: SignaturePad) => {
        sigPad?.clear();
        if(signature){
            const trimmedSignature = signature.replace(/\\/g, '');
            const ratio = this.getCanvasRatio();
            sigPad?.fromDataURL(`data:image/svg+xml,${trimmedSignature}`, { ratio });
        }
    }

    ngOnInit(): void {
        this.resizeCanvas();
        if (this.canvas?.nativeElement) {
            this.singaturePad = new SignaturePad(this.canvas?.nativeElement);
            this.singaturePad?.off();
        }
    }

    private resizeCanvas() {
        const canvas = this.canvas?.nativeElement;
        
        if (!canvas) {
            return;
        }

        const ratio = this.getCanvasRatio();
    
        // This part causes the canvas to be cleared
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d")?.scale(ratio, ratio);
    }

    /*
    * When zoomed out to less than 100%, for some very strange reason,
    * some browsers report devicePixelRatio as less than 1
    * and only part of the canvas is cleared then.
    */
    private getCanvasRatio = () => Math.max(window.devicePixelRatio || 1, 1);


    signForm = () => {
        this.modalService
            .openSignatureModal("Sign Form", "")
            .then((display: string) => {
                firstValueFrom(
                    this.signatureService.saveSignature({ display, user: '' })
                ).then(() => {
                    this.signature = display;
                });
            });
    }

    removeSignature = () =>{
        this.signature = undefined;
    }

    writeValue = (obj: any): void => {
        this._signature = obj;
        this.setSignature(this._signature, this.singaturePad)
    }

    registerOnChange = (fn: any): void => {
        this.onChangeCallback = fn;
    }

    registerOnTouched = (fn: any): void => {
        this.onTouchedCallback = fn;
    }

    setDisabledState = (isDisabled: boolean): void => {
        this.disabled = isDisabled;
    }

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

}
